import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Heading, Text } from '@zillow/constellation-10';

import RMWInput from '../../../RMWInput';
import propertyUtils from '../../../../utils/propertyUtils';

const propTypes = {
  selectedItem: PropTypes.object.isRequired,
  submitErrorMessage: PropTypes.string,
  handleUnitNumberBlur: PropTypes.func.isRequired,
};
const defaultProps = {
  submitErrorMessage: '',
};

const UnitNumber = ({ selectedItem, submitErrorMessage, handleUnitNumberBlur, clearFieldError }) => {
  const { currentProperty } = useSelector((state) => state.properties);
  const { formattedCompleteAddress } = propertyUtils.formatAddress(currentProperty);

  return (
    <>
      <Heading level={4} css={{ marginBottom: '400' }}>
        Unit address
      </Heading>
      <Text asChild css={{ marginBottom: '400' }}>
        <p>{`Please confirm the unit number for ${formattedCompleteAddress}.`}</p>
      </Text>
      <RMWInput
        disabled={!selectedItem.id}
        initialValue={selectedItem.unitName}
        errorMessage={submitErrorMessage}
        label="Unit number"
        placeholder="(Optional)"
        onBlur={handleUnitNumberBlur}
        leftAdornment="#"
        inputType="adorned"
        maxLength="20"
      />
    </>
  );
};

UnitNumber.defaultProps = defaultProps;
UnitNumber.propTypes = propTypes;

export default UnitNumber;
